export class BannerErrorConfigModel {
    errorId: string;
    label: string;
}

export class StepsBannerErrorConfigModel extends BannerErrorConfigModel {
    tab: number;
}
